import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import titleClasses from './Title.module.scss';

export default function Title(props) {
  const { type = 'h1', color, className, style, children } = props;
  const cs = cx(
    titleClasses.title,
    { [titleClasses[`color-${color}`]]: color !== undefined },
    className,
  );
  return React.createElement(type, { className: cs, style }, children);
}

Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.oneOf([
    'primary',
    'font-primary',
    'font-secondary',
    'secondary',
    'accent',
    'warning',
    'error',
    'white',
    'grey-400',
    'grey-300',
  ]),
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span']),
};
